import request from  '../request'

export function login(params = {}){
    return request({
        method:'POST',
        url:'/login/password/check',
        data:params
    })
}
// 修改密码
export function setPwd(params = {}){
    return request({
        method:'PUT',
        url:'/verify/manager/password',
        params
    })
}

